<template>
    <ItemMenuWrapper :label="label" v-slot="{ inputId }">
        <InputNumber v-if="mostrarInput" :id="inputId" :modelValue="modelValue" @update:modelValue="handleUpdate" :max="max" :min="min" />
        <Slider style="margin: 4px 4px 0px 4px" :modelValue="modelValue" @update:modelValue="handleUpdate" :min="min" :max="max" />
    </ItemMenuWrapper>
</template>

<script setup>
import ItemMenuWrapper from './ItemMenuWrapper.vue';
import { defineEmits, defineProps } from 'vue';

defineProps({
    label: {
        type: String,
    },
    modelValue: {
        type: Number,
        default: 0,
    },
    min: {
        type: Number,
        default: 0,
    },
    max: {
        type: Number,
        default: 100,
    },
    mostrarInput: {
        type: Boolean,
        default: true,
    },
});

const emit = defineEmits(['update:modelValue']);

const handleUpdate = (value) => {
    emit('update:modelValue', value);
};
</script>
